import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './components/ui/Button';
import { useSignIn, useSignUp } from '@clerk/clerk-react';
import { isSessionExists } from './lib/clerkErrors';

export default function AuthChoice() {
  const navigate = useNavigate();
  const { isLoaded: isSignInLoaded, signIn } = useSignIn();
  const { isLoaded: isSignUpLoaded, signUp } = useSignUp();
  const [error, setError] = useState<string | null>(null);

  const redirect = '/sso-return';

  const handleSignIn = async () => {
    setError(null);
    try {
      if (!isSignInLoaded || !signIn) throw new Error('Sign-in not ready');
      await signIn.authenticateWithRedirect({
        strategy: 'oauth_google',
        redirectUrl: redirect,
        redirectUrlComplete: redirect,
      });
    } catch (e: unknown) {
      if (isSessionExists(e)) { navigate('/', { replace: true }); return; }
      const msg = (e as { message?: string })?.message;
      setError(msg || 'Failed to start Google sign-in');
    }
  };

  const handleSignUp = async () => {
    setError(null);
    try {
      if (!isSignUpLoaded || !signUp) throw new Error('Sign-up not ready');
      await signUp.authenticateWithRedirect({
        strategy: 'oauth_google',
        redirectUrl: redirect,
        redirectUrlComplete: redirect,
      });
    } catch (e: unknown) {
      if (isSessionExists(e)) { navigate('/', { replace: true }); return; }
      const msg = (e as { message?: string })?.message;
      setError(msg || 'Failed to start Google sign-up');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-secondary px-4">
      <div className="w-full max-w-sm rounded-xl border border-primary bg-bg-primary p-6 shadow-sm">
        <h1 className="mb-4 text-lg font-semibold text-content-primary">Continue with Google</h1>
        {error ? <p className="mb-3 text-xs text-content-danger">{error}</p> : null}
        <div className="space-y-3">
          <Button variant="indigo" className="w-full" onClick={() => { void handleSignIn(); }}>
            Sign in with Google
          </Button>
          <Button variant="neutral" className="w-full" onClick={() => { void handleSignUp(); }}>
            Create account with Google
          </Button>
        </div>
      </div>
    </div>
  );
}


